"use client";
import { StaticBreadcrumbsModel } from "@/types/StaticBreadcrumb";
import { useScrollPosition } from "@/services/scroll-position-service";
import { HomeIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function StaticBreadcrumb({
  breadcrumbs,
}: {
  breadcrumbs: StaticBreadcrumbsModel;
}) {
  const scrollPosition = useScrollPosition();
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    if (scrollPosition > 2) {
      setIsScroll(true);
    }

    if (scrollPosition == 0) {
      setIsScroll(false);
    }
  }, [scrollPosition]);

  return (
    <nav
      aria-label="Breadcrumb"
      className={clsx(
        " border-b border-t border-gray-200",
        isScroll ? "bg-white" : "",
      )}
    >
      <ol
        role="list"
        className={`flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8 ${
          breadcrumbs.breadcrumbs ? "" : "h-[50px]"
        }`}
      >
        <li className="flex">
          <div className="flex items-center">
            <Link
              href={breadcrumbs.home.link}
              className="flex text-gray-400 hover:text-gray-500"
            >
              <HomeIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0" />
              <span className="sr-only">{breadcrumbs.home.name}</span>
            </Link>
          </div>
        </li>
        {breadcrumbs.breadcrumbs &&
          breadcrumbs.breadcrumbs.map((page) => (
            <li key={page.name} className="flex">
              <div className="flex items-center">
                <svg
                  fill="currentColor"
                  viewBox="0 0 24 44"
                  preserveAspectRatio="none"
                  aria-hidden="true"
                  className="h-full w-6 flex-shrink-0 text-gray-200"
                >
                  <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                </svg>
                <Link
                  href={page.link}
                  aria-current={page.current ? "page" : undefined}
                  className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >
                  {page.name}
                </Link>
              </div>
            </li>
          ))}
      </ol>
    </nav>
  );
}
